import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c7e3b1c")

_pushScopeId("data-v-2c7e3b1c")
const _hoisted_1 = {
  key: 0,
  class: "hotels-search-card ovh hoverShadow"
}
const _hoisted_2 = { class: "hotels-search-card-info" }
const _hoisted_3 = { class: "hotels-search-card-info-header" }
const _hoisted_4 = { class: "hotels-search-card-info-header__title" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_hotel_stars = _resolveComponent("hotel-stars")
  const _component_hotel_service = _resolveComponent("hotel-service")
  const _component_hotel_main_info = _resolveComponent("hotel-main-info")
  const _component_hotel_image = _resolveComponent("hotel-image")
  const _component_hotel_card_footer = _resolveComponent("hotel-card-footer")

  return (_ctx.item)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_hotel_stars, { item: _ctx.item }, null, 8, ["item"]),
            _createVNode("h3", _hoisted_4, _toDisplayString(_ctx.item.hotelName.bs.rus), 1),
            _createVNode(_component_hotel_service, { item: _ctx.item }, null, 8, ["item"])
          ]),
          _createVNode(_component_hotel_main_info, {
            item: _ctx.item,
            parseDate: _ctx.parseDate
          }, null, 8, ["item", "parseDate"])
        ]),
        _createVNode(_component_hotel_image, { item: _ctx.item }, null, 8, ["item"]),
        _createVNode(_component_hotel_card_footer, {
          toggleDisplay: _ctx.openModalPrice,
          item: _ctx.item,
          isModeOffer: _ctx.isModeOffer,
          onSelectOffer: _ctx.selectTiket,
          onUnselectOffer: _cache[1] || (_cache[1] = $event => (_ctx.$emit('unselect-offer', null))),
          isCansel: _ctx.isCansel,
          hasCansel: _ctx.hasCansel,
          hasControl: _ctx.hasControl
        }, null, 8, ["toggleDisplay", "item", "isModeOffer", "onSelectOffer", "isCansel", "hasCansel", "hasControl"])
      ]))
    : _createCommentVNode("", true)
})